<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/164jvKs/tc-custom/9781459206700.jpg?1700281120675" alt="This image is the cover for the book Husband Assignment"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Husband Assignment
      </h1>
      <p class="bookDescription body article font2">
        <p>When Stephanie accepted an assignment to publicize a major film, she found herself having to negotiate with Raoul lanier, the powerful heir to a billionaire empire—and a ruthlessly sexy man…<br/><br/>Stephanie simply had to stop fantasizing about Raoul. It was his <i>business</i> expertise she must concentrate on, not his bedroom technique! After all, they had a financial deal to settle. But then it became clear that the only merger Raoul had in mind was marriage!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Helen Bianchin
      </h2>
      
      <p class="authorDescription body article">Helen Bianchin was encouraged by a friend to write her own romance novel and she hasn&rsquo;t stopped writing since! Helen&rsquo;s interests include a love of reading, going to the movies, and watching selected television programs. She also enjoys catching up with friends, usually over a long lunch! A lover of animals, especially cats, she owns two beautiful Birmans. Helen lives in Australia with her husband. Their three children and six grandchildren live close by.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2e4c9de4